import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "ItemTesoreriaPage",
    data() {
        let ss = new MainService();
        return {
            msg: "ItemTesoreriaPage",
            ss: ss,
            ajax: {
                "url": ss.indexItemTesoreria(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'ItemTesoreria', name: 'ItemTesoreria', title: 'Nombre del item' },
                { data: 'Codigo', name: 'Codigo', title: 'Codigo' },
                { data: 'Monto', name: 'Monto', title: 'Monto' },
                { data: 'NivelAcademico', name: 'NivelAcademico', title: 'NivelAcademico' },
                { data: 'UnidadAcademica', name: 'UnidadAcademica', title: 'UnidadAcademica' },
                { data: 'CategoriaProgramatica', name: 'CategoriaProgramatica', title: 'CategoriaProgramatica' },
                { data: 'Reparticion', name: 'Reparticion', title: 'Reparticion' },
                { data: 'Cuenta', name: 'Cuenta', title: 'Cuenta' },
                { data: 'Subcuenta', name: 'Subcuenta', title: 'Subcuenta' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            itemstesoreria: [],
            itemtesoreria: {},
            isLoading: false,
            errorBag: {},
            nievelesacademicos: [],
            unidadacademicas: [],
            categoriasprogramaticas: [],
            reparticiones: [],
            rubros: [],
            cuentas: [],
            subcuentas: [],
        };
    },
    methods: {
        getNivelAcademico() {
            this.ss.listNivelAcademico().then(
                (result) => {
                    let response = result.data;
                    this.nivelesacademicos = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getUnidadAcademica() {
            this.ss.listUnidadAcademica().then(
                (result) => {
                    let response = result.data;
                    this.unidadacademicas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getCategoriaProgramatica() {
            this.ss.listCategoriaProgramatica().then(
                (result) => {
                    let response = result.data;
                    this.categoriasprogramaticas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getReparticion() {
            this.ss.listReparticion(0).then(
                (result) => {
                    let response = result.data;
                    this.reparticiones = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getRubro() {
            this.ss.listRubro().then(
                (result) => {
                    let response = result.data;
                    this.rubros = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getCuenta() {
            this.ss.listCuenta().then(
                (result) => {
                    let response = result.data;
                    this.cuentas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getSubcuenta() {
            this.ss.listSubcuenta().then(
                (result) => {
                    let response = result.data;
                    this.subcuentas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        ////////////////////////////////////////////////////////////
        newItemTesoreria() {
            this.itemtesoreria = {};
            this.$refs['frm-itemtesoreria'].show();
        },
        showItemTesoreria(id) {
            this.isLoading=true;
            this.ss.showItemTesoreria(id).then(
                (result) => {
                    let response = result.data;
                    this.itemtesoreria = response.data;
                    this.$refs['view-itemtesoreria'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editItemTesoreria() {
            this.$refs['frm-itemtesoreria'].show();
            this.$refs['view-itemtesoreria'].hide();
        },
        cancelItemTesoreria() {
            if (this.itemtesoreria.id) {
                this.$refs['view-itemtesoreria'].show();
            }
            this.$refs['frm-itemtesoreria'].hide();
        },
        saveItemTesoreria() {
            this.ss.storeItemTesoreria(this.itemtesoreria).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-itemtesoreria'].hide();
                    this.$refs['datatable-itemtesoreria'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteItemTesoreria() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyItemTesoreria(this.itemtesoreria)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-itemtesoreria'].hide();
                                this.$refs['datatable-itemtesoreria'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-ItemTesoreria').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showItemTesoreria(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }else{
            this.getNivelAcademico();
            this.getUnidadAcademica();
            this.getCategoriaProgramatica();
            this.getReparticion(0);
            this.getRubro();
            this.getCuenta();
            this.getSubcuenta();
        }
        
    }
};
